import { FC, FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import PersonIcon from '@mui/icons-material/Person'
import { Box, Button, Stack } from '@mui/material'

import { LocalStorageKey, removeLocalStorageValue } from '@/common/utils/localStorage'
import { useAuth } from '@/modules/authentication'
import { IconField } from '@/modules/authentication/IconField'

const LoginFormOIDC: FC<{ initialEmail: string; providerId: string }> = ({
  initialEmail,
  providerId,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { signOut } = useAuth()

  return (
    <Box
      component="form"
      onSubmit={(e: FormEvent) => {
        e.preventDefault()
        navigate(`/oidc/login?gidp_provider_id=${encodeURIComponent(providerId)}`)
      }}
    >
      <Stack spacing={2}>
        <IconField
          disabled
          name="email"
          value={initialEmail}
          placeholder={t('login.emailAddress', 'EMAIL ADDRESS')}
          icon={<PersonIcon color="action" />}
        />
        <Button type="submit" variant="contained" fullWidth size="large">
          {t('login.SSOLogin', 'Login via SSO')}
        </Button>
        <Button
          type="button"
          variant="outlined"
          fullWidth
          onClick={async () => {
            removeLocalStorageValue(LocalStorageKey.USER)
            signOut()
          }}
        >
          {t(
            'login.SSOSwitchEmail',
            'Not {{initialEmail}}? Login with a different email address.',
            {
              initialEmail,
            }
          )}
        </Button>
      </Stack>
    </Box>
  )
}

export default LoginFormOIDC
